var render = function render(){var _vm=this,_c=_vm._self._c;return _c('KFixedGrid',{attrs:{"numCols":_vm.windowGridColumns,"gutter":_vm.gutter,"gridStyle":_vm.gridStyle,"debug":_vm.debug}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }